/**
 * 前端运行时配置,对应产品文档 §9(部署后由 CDK Outputs 填入)。
 *
 * 这些值在 CDK 部署完成后才能确定(API Gateway URL、Cognito Pool Id/Client Id
 * 都是部署时生成的),因此不写死在代码里,而是从构建时的环境变量注入
 * (Vite 约定:VITE_ 前缀的变量会被静态替换进产物)。
 *
 * 本机开发时可以创建 frontend/.env.local 文件填入实际值,或用
 * `npm run dev` 时的 shell 环境变量传入。CDK FrontendStack 部署完成后,
 * CI/CD 流程应在构建前端产物之前把这些值写入 .env.production。
 */
export const config = {
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL ?? "",
  cognitoUserPoolId: import.meta.env.VITE_COGNITO_USER_POOL_ID ?? "",
  cognitoClientId: import.meta.env.VITE_COGNITO_CLIENT_ID ?? "",
  cognitoRegion: import.meta.env.VITE_COGNITO_REGION ?? "",
  // Kiro-Go 舰队管理器有自己独立的 API Gateway RestApi(kiro-go-fleet-api,
  // 见 infra/lib/fleet-stack.ts),base URL 与既有平台的 apiBaseUrl 不同,
  // 但共享同一套 Cognito 登录鉴权机制(见 api/client.ts 的 createApiClient)。
  fleetApiBaseUrl: import.meta.env.VITE_FLEET_API_BASE_URL ?? "",
};

export function assertConfigured(): void {
  const missing = Object.entries(config)
    .filter(([, v]) => !v)
    .map(([k]) => k);
  if (missing.length > 0) {
    // eslint-disable-next-line no-console
    console.warn(
      `前端配置缺失以下环境变量,登录/API 调用将无法工作: ${missing.join(", ")}。` +
        "请参考 frontend/README.md 配置 .env.local。"
    );
  }
}
